import { Grid, styled } from "@mui/material";

import Select from "components/Select";
import { useFormContext } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

function TradeType({ tradeInitial }) {
  const { setValue, watch } = useFormContext();
  const tradeTypeId = watch("tradeTypeId");

  const [searchParams, setSearchParams] = useSearchParams();

  const setIsPrice = (val) => {
    const selectedTradeType = tradeInitial?.lisTradeType?.find(
      (tradeType) => tradeType?.id === val
    );

    setValue("isPrice", selectedTradeType?.isPrice);
  };

  const handleChange = (e) => {
    const val = e?.target?.value;

    const allSearchParams = Object.fromEntries([...searchParams]);
    setSearchParams({ ...allSearchParams, tradeTypeId: val });

    setValue("tradeTypeId", val);

    setIsPrice(val);
  };

  return (
    <Grid container mb={1}>
      <Grid item xs={12}>
        <SelectStyle
          items={tradeInitial?.lisTradeType}
          itemValue="id"
          itemText="name"
          justifyContent="center"
          value={tradeTypeId}
          onChange={handleChange}
        />
      </Grid>
    </Grid>
  );
}

const SelectStyle = styled(Select)(({ theme }) => ({
  textAlign: "center",
  ".MuiSelect-select": {
    padding: theme.spacing(0.5, 2.5),
    fontSize: "12px",
  },
}));

export default TradeType;
